<template>
    <div style="height:100%;">
        <p style="display: flex;
         font-size: 30px;
         flex-direction: row;
         height: 45px;
         color: rgb(221,114,2);
         border-bottom: solid 0.06rem rgb(193,193,193);">
          WEAT enrichment analysis: Brain Expression
        </p> 
        <el-card style="width:100%;
        height:auto;
        margin-left: auto;
        margin-right: auto;
        margin-top: 15px;">
            <div style="width:95%;display: inline-block;vertical-align: middle;margin:auto;font-size: 18px;text-align: left;line-height: 30px;">
            In this section, we show the results of <strong style="font-size:22px;">GO enrichment</strong> analysis and <strong style="font-size:22px;">KEGG pathway enrichment</strong> analysis 
            using the weighted enrichment analysis tool <a href="http://www.cuilab.cn/weat/">WEAT</a>. 
            We used the gene scores generated from GTEx_smts brain expression , which was derived from the WEAT method study to weight each gene.
            </div>
        </el-card>    
        <el-tabs style="height:100%;margin-top: 50px;" type="border-card" v-model="activePane" @tab-click="handleClick">
        <!-- Data -->
            <el-tab-pane label="GO enrichment" name="go">
                Select domains: 
                <el-select @change="selectChanged" v-model="activeType" placeholder="Choose type" >
                    <el-option
                        v-for="item in typeOption"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
                <br/><br/>
                <BubblechartVue :plotData="plotData" :name="yaxis" v-if="activePane=='go'"></BubblechartVue>
                <el-table ref="GOtable" class="table" :data="tableData"  style="width: 98%;margin: auto;" height=650px @sort-change='sortChange' :cell-style="{'text-align':'center'}" :header-cell-style="{'text-align':'center'}"   >
                    <el-table-column v-for='(item,key)  in tableFields' :key='key' :formatter="item.formatter" :prop='item.key' :label='item.label' :sortable="item.sortable" :width="item.width" :min-width="item.minWidth"/>          
                </el-table>
                <el-pagination
                    @size-change="(val) => handleSizeChange(val)"
                    @current-change="(val) => handleCurrentChange(val)"
                    :current-page="currentPage"
                    :page-sizes="[10,20,30]"
                    :page-size="10"
                    layout="->,total, sizes, prev, pager, next, jumper"
                    :total= this.totalCount
                    style="margin-left:auto">
                </el-pagination>
            </el-tab-pane>
            <el-tab-pane label="KEGG pathway enrichment" name="kegg">
                <br/><br/>
                <BubblechartVue :plotData="KEGGData" :name="yaxis" v-if="activePane=='kegg'"></BubblechartVue>
                <el-table ref="KEGGtable" class="table" :data="tableData"  style="width: 98%;margin: auto;" height=650px @sort-change='sortChange' :cell-style="{'text-align':'center'}" :header-cell-style="{'text-align':'center'}"   >
                    <el-table-column v-for='(item,key)  in tableFields' :key='key' :formatter="item.formatter" :prop='item.key' :label='item.label' :sortable="item.sortable" :width="item.width" :min-width="item.minWidth"/>          
                </el-table>
                <el-pagination
                    @size-change="(val) => handleSizeChange(val)"
                    @current-change="(val) => handleCurrentChange(val)"
                    :current-page="currentPage"
                    :page-sizes="[10,20,30]"
                    :page-size="10"
                    layout="->,total, sizes, prev, pager, next, jumper"
                    :total= this.totalCount
                    style="margin-left:auto">
                </el-pagination>
            </el-tab-pane>
           
        </el-tabs>
    </div>
</template>

<script>
import BubblechartVue from '../../../chart/BubbleWeatchart.vue';
import{Loading}from'element-ui';
export default{
    data(){    
        return{
            tableData:[],
            yaxis:'GO term',
            // 默认显示第几页
            currentPage:1,
            // 总条数，根据接口获取数据长度(注意：这里不能为空)
            totalCount:1,
            // 默认每页显示的条数（可修改）
            pageSize:10,
            desc:null,
            sortby:null,
            activePane:"go",
            activeType:'Biological Process',
            tableFields: [
                { key: "description", label: "Description", sortable: true,width:'150px'},
                { key: "count_ratio", label: "Count ratio", sortable: true,width:120},
                { key: "score_ratio", label: "Score ratio", sortable: true,width:120},
                { key: "or", label: "OR", sortable: true,width:100},
                { key: "wor", label: "WOR", sortable: true,width:110},
                { key: "wpvalue", label: "WP-value", sortable: true ,width:110},
                { key: "bonferroni", label: "Bonferroni",sortable: true ,width:120,formatter:this.rounding},
                { key: "fdr", label: "FDR",sortable: true ,width:100,formatter:this.rounding},
                { key: "gene_name", label: "Gene name", sortable: true,minWidth:350},
                // { key: "type", label: "Category", sortable: true,width:120},
                // { key: "background", label: "Score generation", sortable: true,width:120}
            ],
            typeOption:[{
                value: 'Biological Process',
                label: 'Biological Process'
                },{
                value: 'Cellular Component',
                label: 'Cellular Component'
                },{
                value: 'Molecular Function',
                label: 'Molecular Function'
                }],
            plotData: null,
            BPData:[[0.321389352096636,'chemical synaptic transmission','79/246','6.18','79.02/245.87','6.2',3.74E-30,4.59E-26,4.59E-26,79,29.4271283977995],
                [0.171963617930889,'signal transduction','180/1047','2.82','179.80/1045.57','2.83',2.15E-27,2.64E-23,1.32E-23,180,26.6675615400844],
                [0.276254508526806,'cytokine-mediated signaling pathway','79/286','4.97','78.89/285.57','4.98',3.98E-25,4.88E-21,1.63E-21,79,24.4001169279263],
                [0.276243518340695,'response to drug','72/256','5.07','71.92/260.35','4.96',8.27E-23,1.01E-18,2.54E-19,72,22.0824944904475],
                [0.226946509706733,'inflammatory response','88/388','3.83','87.91/387.36','3.84',2.36E-21,2.89E-17,5.79E-18,88,20.6270879970299],
                [0.222088647292494,'positive regulation of gene expression','85/383','3.71','84.98/382.64','3.72',3.78E-20,0.000000000000000463,7.72E-17,85,19.4225082001628],
                [0.333357521224875,'response to lipopolysaccharide','46/138','6.39','45.94/137.81','6.4',9.9E-19,0.0000000000000121,0.00000000000000174,46,18.0043648054024],
                [0.294645601524559,'response to hypoxia','48/156','5.68','47.93/162.67','5.35',6.24E-17,0.000000000000765,0.0000000000000956,48,16.2048154103176],
                [0.282590759075908,'aging','48/156','5.68','47.95/169.68','5.04',0.000000000000000387,0.00000000000475,0.000000000000528,48,15.4122890349811],
                [0.416747809152872,'circadian rhythm','30/72','9.04','29.96/71.89','9.06',0.000000000000000978,0.000000000012,0.0000000000012,30,15.0096611452124],

                ],
            MFData:[[1,'phenylpyruvate tautomerase activity','2/2','Infinity','2.00/2.00','Infinity',0,0,0,2,50],
                [0.199013342302949,'enzyme binding','71/357','3.24','71.00/356.76','3.25',0.0000000000000108,0.0000000000467,0.0000000000234,71,13.966576244513],
                [0.191942738043001,'signaling receptor binding','70/358','3.17','69.99/364.64','3.1',0.000000000000123,0.000000000533,0.000000000178,70,12.9100948885606],
                [0.240717921242968,'cytokine activity','45/187','4.08','44.93/186.65','4.09',0.0000000000012,0.00000000521,0.0000000013,45,11.9208187539524],
                [0.122391647778007,'identical protein binding','178/1457','1.86','178.19/1455.90','1.87',0.00000000000363,0.0000000157,0.00000000315,178,11.4400933749639],
                [0.245452310717797,'growth factor activity','40/163','4.18','39.94/162.72','4.19',0.0000000000107,0.0000000462,0.0000000077,40,10.9706162223148],
                [0.0820310633020292,'protein binding','1013/12327','1.51','1012.63/12344.47','1.51',0.0000000000756,0.000000328,0.0000000468,1013,10.1214782044988],
                [0.20489520738678,'transcription regulatory region sequence-specific DNA binding','42/205','3.31','41.94/204.69','3.32',0.00000000142,0.00000616,0.00000077,42,8.84771165561694],
                [0.467133800467134,'neuropeptide hormone activity','14/30','11.1','14.00/29.97','11.14',0.00000000636,0.0000276,0.00000306,14,8.19654288435159],
                [0.750208855472013,'serotonin binding','9/12','37.94','8.98/11.97','38.01',0.0000000118,0.000051,0.00000432,9,7.92811799269387],

                ],
            CCData:[[0.145602739652956,'extracellular region','273/1870','2.52','272.96/1874.69','2.51',8.04E-32,1.42E-28,1.42E-28,273,31.0947439512515],
                [0.24726337700502,'dendrite','101/406','4.55','100.97/408.35','4.52',8.89E-29,1.56E-25,7.82E-26,101,28.0510982390298],
                [0.145366608153395,'extracellular space','237/1630','2.45','236.84/1629.26','2.46',2.91E-27,5.13E-24,1.71E-24,237,26.5361070110141],
                [0.147149040470945,'integral component of plasma membrane','208/1414','2.45','207.72/1411.63','2.46',1.73E-24,3.05E-21,7.61E-22,208,23.7619538968712],
                [0.104451170941533,'plasma membrane','492/4714','1.8','491.73/4707.75','1.8',3.28E-22,5.76E-19,1.15E-19,492,21.4841261562883],
                [0.239743509929652,'neuron projection','77/321','4.27','77.02/321.26','4.27',3.96E-21,6.97E-18,1.16E-18,77,20.4023048140745],
                [0.234744183250165,'neuronal cell body','78/330','4.19','78.09/332.66','4.16',5.03E-21,8.86E-18,1.27E-18,78,20.2984320149441],
                [0.223928700628145,'glutamatergic synapse','68/304','3.87','68.09/304.07','3.88',0.000000000000000015,0.0000000000000264,0.0000000000000033,68,16.8239087409443],
                [0.215196581762777,'axon','65/302','3.67','64.97/301.91','3.68',0.000000000000000705,0.00000000000124,0.000000000000138,65,15.1518108830086],
                [0.283878753460637,'postsynaptic membrane','40/141','5.25','39.99/140.87','5.26',0.0000000000000229,0.0000000000403,0.00000000000403,40,13.6401645176601],

            ],
            KEGGData: [[0.328729281767956,'Neuroactive ligand-receptor interaction','119/362','4.78','118.12/356.29','4.69',8.86E-32,3.1E-29,3.1E-29,119,31.0525662781129],
                [0.412280701754386,'Glutamatergic synapse','47/114','6.38','48.62/115.95','6.4',4.87E-18,0.0000000000000017,0.000000000000000852,47,17.3124710387854],
                [0.304166666666667,'Calcium signaling pathway','73/240','4.06','72.64/241.96','3.86',6.36E-17,0.0000000000000223,0.00000000000000742,73,16.1965428843516],
                [0.297674418604651,'Lipid and atherosclerosis','64/215','3.9','65.18/219.55','3.77',0.0000000000000051,0.00000000000179,0.000000000000446,64,14.2924298239021],
                [0.373913043478261,'Serotonergic synapse','43/115','5.4','43.59/115.31','5.35',0.0000000000000134,0.00000000000469,0.000000000000938,43,13.8728952016352],
                [0.385321100917431,'HIF-1 signaling pathway','42/109','5.67','42.51/114.47','5.19',0.0000000000000399,0.000000000014,0.00000000000233,42,13.3990271043133],
                [0.289592760180996,'cAMP signaling pathway','64/221','3.74','64.72/225.80','3.58',0.0000000000000586,0.0000000000205,0.00000000000293,64,13.2321023839819],
                [0.382978723404255,'IL-17 signaling pathway','36/94','5.58','36.79/94.79','5.55',0.000000000000418,0.000000000146,0.0000000000183,36,12.378823718225],
                [0.207156308851224,'Pathways in cancer','110/531','2.46','110.98/532.10','2.4',0.000000000000923,0.000000000323,0.0000000000359,110,12.0347982989741],
                [0.510204081632653,'Cocaine addiction','25/49','9.28','25.30/50.04','8.86',0.00000000000272,0.000000000953,0.0000000000953,25,11.5654310959658],
            ]
        }
    },
    components:{
        BubblechartVue
    },
    mounted () {
        this.plotData=this.BPData
        this.getData()
    },
    methods:{
        getData(){
            console.log(this.activePane=="go"?this.activeType:"KEGG")
            var loadingInstance = Loading.service({
                target:document.querySelector('.table')
            });
            this.axios.get(this.GLOBAL.rootAddress+'analysis/enrichment/weat_gtxbrain',{
            params: { 
                'pageNum': this.currentPage,
                'pageSize': this.pageSize,
                'sortBy':this.sortby,
                'desc':this.desc,
                'type':this.activePane=="go"?this.activeType:"KEGG"
            }
            })
            .then(response=> {
                loadingInstance.close();
                this.totalCount=response.data.data.total;               
                this.tableData=response.data.data.records;   
            })
            .catch(error=> {
                loadingInstance.close();
                console.log(error);
            });
        },
        handleClick(val){
            this.getData() 
            this.currentPage=1
            if(this.activePane=='go')this.yaxis="GO term"
            else this.yaxis="KEGG pathway"
        },
        // 改变每页显示的条数 
        handleSizeChange(val) { 
            this.pageSize=val
            this.currentPage=1
            this.getData()            
            },
        // 改变当前页数
        handleCurrentChange(val) {
            this.currentPage=val
            this.getData()
        },
        sortChange(column, prop, order){
            this.currentPage=1
            if(column.order){
                this.sortby=column.prop
                if(column.order=='ascending'){
                    this.desc=1
                }else this.desc=0
            }else{
                this.sortby=null
                this.desc=null
            }
            this.getData()
        },
        rounding(row,column) {
            return row[column.property].toExponential(3)
        },
        selectChanged(){
            if(this.activeType=='Biological Process'){
                this.plotData=this.BPData
            }else if(this.activeType=='Cellular Component'){
                this.plotData=this.CCData
            }else {
                this.plotData=this.MFData
            }
            if (this.$refs.table){
                this.$refs.table.clearSort()
            }
            this.currentPage=1
            this.currentPageIndex=0
            this.desc=null
            this.sortby=null
            this.pageSize=10
            this.getData()
        },

    },
}


</script>

<style>

</style>